import { render, staticRenderFns } from "./ph-table.vue?vue&type=template&id=16865272&scoped=true"
import script from "./ph-table.vue?vue&type=script&lang=js"
export * from "./ph-table.vue?vue&type=script&lang=js"
import style0 from "./ph-table.vue?vue&type=style&index=0&id=16865272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16865272",
  null
  
)

export default component.exports